<div class="modal-header bg-dark">
    <h4 class="modal-title">Nuova <strong>Nota</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body">
    <label class="control-label" for="note-text">Testo</label>
    <textarea id="note-text"
              class="form-control form-white"
              rows="6"
              [(ngModel)]="noteText"
              placeholder="Scrivi una nuova nota..."></textarea>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn btn-default btn-blue btn-embossed"
            (click)="confirm()"
            [disabled]="!noteText.trim()">
        Conferma
    </button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Annulla</button>
</div>
